module.exports = __webpack_public_path__ + "static/media/icon-piece-4.ea70d62a.png";